import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProviderCompanyDetailFetchSuccess,
    getProviderCompanyDetailFetchFailure,
    createProviderCompanyDetailFetchSuccess,
    createProviderCompanyDetailFetchFailure,
    updateProviderCompanyDetailFetchSuccess,
    updateProviderCompanyDetailFetchFailure,
    deleteProviderCompanyFetchSuccess,
    deleteProviderCompanyFetchFailure,
} from './reducer';
import { ProviderCompanyDetailResType } from 'src/types/providerCompanyDetail';
import { ProviderCompanyType } from 'src/types/providerCompany';
import translate from '@translate';

const getProviderCompanyDetailFetchRequest = async (idProviderCompany: string) => {
    const res = await api('get', `api/secure/provider-companies/${idProviderCompany}`);
    return res.data;
};

function* getProviderCompanyDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProviderCompanyDetailResType = yield call((): any =>
            getProviderCompanyDetailFetchRequest(action.payload)
        );
        yield put(getProviderCompanyDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProviderCompanyDetailFetchFailure({ error }));
    }
}

export function* getProviderCompanyDetailFetchWatch() {
    yield takeEvery('providerCompanyDetail/getProviderCompanyDetailFetch', getProviderCompanyDetailFetch);
}

const createProviderCompanyDetailFetchRequest = async (data: ProviderCompanyType) => {
    const res = await api('post', 'api/secure/provider-companies', data);
    return res.data;
};

function* createProviderCompanyDetailFetch(action: { type: string; payload: ProviderCompanyType }) {
    try {
        const response: ProviderCompanyDetailResType = yield call((): any =>
            createProviderCompanyDetailFetchRequest(action.payload)
        );
        yield put(
            createProviderCompanyDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providerCompanyDetail.message.providerCompanyCreated') },
            })
        );
    } catch (error) {
        yield put(createProviderCompanyDetailFetchFailure({ error }));
    }
}

export function* createProviderCompanyDetailFetchWatch() {
    yield takeEvery('providerCompanyDetail/createProviderCompanyDetailFetch', createProviderCompanyDetailFetch);
}

const updateProviderCompanyDetailFetchRequest = async (params: {
    idProviderCompany: string;
    data: ProviderCompanyType;
}) => {
    const res = await api('put', `api/secure/provider-companies/${params.idProviderCompany}`, params.data);
    return res.data;
};

function* updateProviderCompanyDetailFetch(action: {
    type: string;
    payload: { idProviderCompany: string; data: ProviderCompanyType };
}) {
    try {
        const response: ProviderCompanyDetailResType = yield call((): any =>
            updateProviderCompanyDetailFetchRequest(action.payload)
        );
        yield put(
            updateProviderCompanyDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providerCompanyDetail.message.providerCompanyUpdate') },
            })
        );
    } catch (error) {
        yield put(updateProviderCompanyDetailFetchFailure({ error }));
    }
}

export function* updateProviderCompanyDetailFetchWatch() {
    yield takeEvery('providerCompanyDetail/updateProviderCompanyDetailFetch', updateProviderCompanyDetailFetch);
}

const deleteProviderCompanyFetchRequest = async (idProviderCompany: string) => {
    const res = await api('delete', `api/secure/provider-companies/${idProviderCompany}`);
    return res.data;
};

function* deleteProviderCompanyFetch(action: { type: string; payload: string }) {
    try {
        const response: ProviderCompanyDetailResType = yield call((): any =>
            deleteProviderCompanyFetchRequest(action.payload)
        );
        yield put(
            deleteProviderCompanyFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providerCompanyDetail.message.providerCompanyDeleted') },
            })
        );
    } catch (error) {
        yield put(deleteProviderCompanyFetchFailure({ error }));
    }
}

export function* deleteProviderCompanyFetchWatch() {
    yield takeEvery('providerCompanyDetail/deleteProviderCompanyFetch', deleteProviderCompanyFetch);
}
